import { IconButton, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { AmountStepperSize } from "web_myplann/Shared/Types/AmountStepperSize";
import type { PressHandlers } from "web_myplann/Shared/Types/PressHandlers";

type Props = {
	size: AmountStepperSize;
	icon: LucideIcon;
	disabled: boolean;
	pressHandlers: PressHandlers;
};

export const AmountStepperButton: FC<Props> = ({
	size,
	icon: Icon,
	disabled,
	pressHandlers,
}) => {
	const { amountStepper } = useTheme();
	const buttonSize = amountStepper.buttonSize[size];

	return (
		<IconButton
			variant="stepper"
			{...pressHandlers}
			disabled={disabled}
			sx={{ width: buttonSize, height: buttonSize }}
		>
			<Icon size={amountStepper.iconSize[size]} />
		</IconButton>
	);
};
